import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Validators} from '@angular/forms';
import {ExtendedFormControl} from '@aviary/forms/extensions/extended-form-control/extended-form-control';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {PasswordFormFieldComponent} from '@aviary/forms/fields/password-form-field/password-form-field.component';
import {buildFormGroup, getExtendedControlFrom} from '@aviary/forms/form.helpers';
import {PersistentFormDialogComponent} from '@aviary/dialogs/persistent-form-dialog/persistent-form-dialog.component';
import {PersistentFormDialog, PersistentFormDialogDefinition} from '@aviary/dialogs/persistent-form-dialog/persistent-form-dialog.types';
import {isIncorrectCurrentPasswordFailure} from '@aviary/services/auth.helpers';
import {ConfirmedPasswordFormFieldComponent} from '@lib/components/confirmed-password-form-field/confirmed-password-form-field.component';

export interface ChangePasswordValue {
  currentPassword: string;
  newPassword: string;
}

@Component({
  selector: 'px-change-password',
  template: `
    <mx-persistent-form-dialog [definition]="dialogDefinition">
      <mx-password-form-field fieldName="currentPassword" overrideLabel="Current Password" [includeClearButton]="false" [formGroup]="formGroup"/>
      <px-confirmed-password-form-field fieldName="newPassword" passwordLabel="New Password" confirmationLabel="Confirm New Password"
                                        [formGroup]="formGroup"/>
    </mx-persistent-form-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PersistentFormDialogComponent, PasswordFormFieldComponent, ConfirmedPasswordFormFieldComponent]
})
export class ChangePasswordDialog implements PersistentFormDialog<Record<string, never>, ChangePasswordValue> {
  public readonly dialogData: Record<string, never> = {};

  public readonly formGroup: ExtendedFormGroup = buildFormGroup<ChangePasswordValue>(
    {currentPassword: '', newPassword: ''},
    {currentPassword: [Validators.required]}
  );
  public readonly dialogDefinition: PersistentFormDialogDefinition<ChangePasswordValue> = {
    title: 'Change Password',
    confirmButtonLabel: 'Change Password',
    formGroup: this.formGroup
  };

  private readonly currentPasswordControl: ExtendedFormControl = getExtendedControlFrom(this.formGroup, 'currentPassword');

  public handleSubmissionFailure(error: unknown): void {
    if (!isIncorrectCurrentPasswordFailure(error)) return;

    this.currentPasswordControl.setErrors({...this.currentPasswordControl.errors, incorrectCurrentPassword: true});
    this.currentPasswordControl.markAsTouched();
  }
}
